//============================================================================
// Name        : editScheduleReducer.ts
// Purpose     : Define store EditSchedule reducer
// Created     : 2019-08-19
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

import { hideScheduleProduction, IEditScheduleAction, IShowScheduleProductionAction, IUpdateStateAction, showScheduleProduction, updateState } from "../actions/editScheduleActions";
import { EditScheduleActions, IEditScheduleState, IProduct, IProduction, IStorageUnit, IUser, IZone } from "../types";

const initialState: IEditScheduleState = {
    showAsLbs: true,
    showAsCases: false,
    product: {} as IProduct,
    qtyOnHandCases: 0,
    qtyOnHandLbs: 0,
    schedulerUsers: [] as IUser[],
    productions: [] as IProduction[],
    pastDueProductions: [] as IProduction[],
    startDay: 0,
    endDay: 0,
    zones: [] as IZone[],
    subzones: [] as IZone[],
    storageUnit: {} as IStorageUnit,

    // Dialogs
    showScheduleProdDialog: false,
    scheduleDialogUserId: -1,
    scheduleDialogUsername: "",

    showConfirmDialog: false,
    confirmDialogTitle: "",
    confirmDialogMsg: "",
    confirmDlgPositiveCb: null,
    confirmDlgNegativeCb: null
};

export default function(state: IEditScheduleState = initialState, action: IEditScheduleAction): IEditScheduleState {
    switch (action.type) {

        //====================================================================
        // Map Actions messages to Action functions
        //====================================================================

        case EditScheduleActions.StoreInitialState:      return updateState(state, action as IUpdateStateAction);
        case EditScheduleActions.UpdateState:            return updateState(state, action as IUpdateStateAction);
        case EditScheduleActions.ShowScheduleProduction: return showScheduleProduction(state, action as IShowScheduleProductionAction);
        case EditScheduleActions.HideScheduleProduction: return hideScheduleProduction(state);

        //====================================================================

        default:
            return state;
    }
}
